// extracted by mini-css-extract-plugin
module.exports = {"main-yellow":"#fcd406","button":"Feedback-module__button___2yvQn","icon":"Feedback-module__icon___240Cf"};